import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module'
import { HeaderComponent } from './header/header.component';
import { AppRoutingModule } from '../app-routing.module';

import { AddressComponent } from './address/address.component';
import { FormsModule } from '@angular/forms';
import { DataService } from './data.service';
import { PhoneMaskDirective } from './phone-mask.directive';
import { PhoneComponent } from './phone/phone.component';
import { PaymentComponent } from './payment/payment.component';


@NgModule({
  declarations: [HeaderComponent, AddressComponent, PhoneMaskDirective, PhoneComponent, PaymentComponent],
  imports: [
    CommonModule,
    MaterialModule,
    AppRoutingModule,

    FormsModule
  ],
  providers: [DataService],
  exports: [
    HeaderComponent,
    AddressComponent,
    PhoneComponent,
    PhoneMaskDirective

  ]
})
export class SharedModule { }
